import React from 'react'

const HomeVideo = () => {
    return (
        <>
            <div className="our-blog" style={{ marginTop: "-60px" }}>
                <div className="container">
                    <div className="row section-row align-items-center">
                        <div className="col-lg-12" style={{ textAlign: "center" }}>
                            {/* Section Title Start */}
                            <div className="section-title">
                                <h3 className="wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Our Video</h3>
                                <h2 className="text-anime-style-3" data-cursor="-opaque" style={{ perspective: 400 }}>
                                    <div className="split-line" style={{ display: 'block', textAlign: "center", position: 'relative' }}>
                                        Our Video
                                    </div>
                                </h2>
                            </div>
                            {/* Section Title End */}
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="post-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="post-featured-image">
                                    <iframe width="360" height="315" src="https://www.youtube.com/embed/P8S__A8aiEU?si=MGr5FQaxIs2HATmL" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="post-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="post-featured-image">
                                  <iframe width="360" height="315" src="https://www.youtube.com/embed/bo53179sSXU?si=yaSbyXCmvY2wfPbt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="post-item wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>
                                <div className="post-featured-image">
                                   <iframe width="360" height="315" src="https://www.youtube.com/embed/l7NcWxVBZZU?si=2guZHvg5JKSoWfxM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}

export default HomeVideo
